import { render } from "@/components/pages/individualWorkSupport/requirement077/Requirement077.html?vue&type=template&id=f4673a42&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement077/Requirement077.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement077/Requirement077.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement077/Requirement077.scss?vue&type=style&index=0&id=f4673a42&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4673a42"]])

export default __exports__